import {
  AppBar,
  Toolbar,
  Typography,
  Chip,
  Box,
  Switch,
  FormControlLabel,
} from "@mui/material";

import AssignmentIcon from "@mui/icons-material/Assignment";

type TaskHeaderProps = {
  title?: string;
  activeTasksCount?: number;
  totalTasksCount?: number;
  masterSwitch?: boolean;
  onMasterSwitchChange?: (checked: boolean) => void;
  isEditing?: boolean;
};

const TaskHeader = ({
  title = "TAREFAS",
  activeTasksCount = 0,
  totalTasksCount = 0,
  masterSwitch = false,
  onMasterSwitchChange,
  isEditing = false,
}: TaskHeaderProps) => {
  return (
    <AppBar
      position="static"
      sx={{ borderRadius: 1, mb: 4, boxShadow: 3 }}
      color="default"
    >
      <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <AssignmentIcon sx={{ mr: 1 }} />
          <Typography variant="h6" color="inherit" component="div">
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {isEditing && onMasterSwitchChange && (
            <FormControlLabel
              control={
                <Switch
                  checked={masterSwitch}
                  onChange={(e) => onMasterSwitchChange(e.target.checked)}
                  size="small"
                />
              }
              label="Ativar todas"
              sx={{ mr: 0 }}
            />
          )}
          {totalTasksCount > 0 && (
            <Chip
              label={`${activeTasksCount}/${totalTasksCount} ativas`}
              size="small"
              color={activeTasksCount > 0 ? "primary" : "default"}
              variant={activeTasksCount > 0 ? "filled" : "outlined"}
            />
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TaskHeader;
